@if (vesselEntry(); as vessel) {
  <div class="npdc-title">
    <div id="titleContainer">
      @if (vessel.content.name) {
        <h1>{{ vessel.content.name }}</h1>
      }
    </div>

    <div class="npdc-title__actions">
      @if (
        authService.user() &&
        (permissions()?.mayUpdate || authService.canInvoke(authService.endpoints.editVesselEntry))
      ) {
        <button mat-flat-button class="npdc-toolbar-button" [routerLink]="'edit'">Edit</button>
        @if (
          authService.user() &&
          (permissions()?.mayDelete ||
            authService.canInvoke(authService.endpoints.deleteVesselEntry))
        ) {
          <button mat-icon-button [matMenuTriggerFor]="optionsMenu" matToolTip="More Actions">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
      }
    </div>
  </div>

  <mat-menu #optionsMenu>
    <button mat-menu-item (click)="deleteVessel()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </mat-menu>

  @if (vessel.content.type) {
    <p>
      <mat-chip-set>
        <mat-chip>
          <span title="{{ vessel.content.type }}"> <b>Type:</b> {{ vessel.content.type }} </span>
        </mat-chip>
      </mat-chip-set>
    </p>
  }

  @if (images.value()) {
    <div id="imageGrid">
      @for (image of images.value()?.items; track image.id; let isLast = $last) {
        <mat-card>
          <a
            mat-card-image
            title="Click for full image"
            href="{{ attachAddr }}{{ image.id }}/_blob"
            target="_blank"
          >
            <app-card-image
              mat-card-image
              alt="{{ image.title || image.filename }}"
              src="{{ attachAddr }}{{ image.id }}/_blob"
            />
          </a>
          <mat-card-content>
            @if (image.title) {
              <h3>{{ image.title }}</h3>
            } @else {
              <h3>{{ image.filename }}</h3>
            }
            @if (image.description) {
              <sub>{{ image.description }}</sub>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  @if (vessel.content.description) {
    <div>
      <h2>Description</h2>
      <div class="npdc-markdown" [innerHtml]="vessel.content.description | markdown"></div>
    </div>
  }

  @if (hasHistory()) {
    <div>
      <h2>History</h2>
      @if (vessel.content.constructionPlace || vessel.content.constructionYear) {
        <h3>Construction</h3>
        {{ vessel.content.name }} was constructed in
        @if (vessel.content.constructionYear) {
          {{ vessel.content.constructionYear }}
        }
        @if (vessel.content.constructionPlace) {
          at {{ vessel.content.constructionPlace }}
        }
        .
      }

      @if (vessel.content.history) {
        <div class="npdc-markdown" [innerHtml]="vessel.content.history | markdown"></div>
      }

      @if (vessel.content.shipwreckedYear || vessel.content.shipwreckedLocation) {
        <h3>Shipwreck</h3>
        @if (vessel.content.shipwreckedYear) {
          {{ vessel.content.name }} was shipwrecked in: {{ vessel.content.shipwreckedYear }}
          @if (vessel.content.shipwreckedLocation) {
            <br />
          }
        }
        @if (vessel.content.shipwreckedLocation) {
          Location: {{ vessel.content.shipwreckedLocation }}
        }
      }
    </div>
  }

  @if (vessel.content.sources) {
    <div>
      <h2>Sources</h2>
      <div class="npdc-markdown" [innerHtml]="vessel.content.sources | markdown"></div>
    </div>
  }

  @if (vessel.content.owners && vessel.content.owners.length) {
    <div>
      <h2>Owners</h2>
      <mat-list>
        @for (owner of vessel.content.owners; track owner.name) {
          <mat-list-item>
            <mat-icon matListItemIcon>id_card</mat-icon>
            <span matListItemTitle>{{ owner.name }}</span>
            @if (owner.location) {
              <span matListItemLine>{{ owner.location }}</span>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  }

  @if (vessel.content.registrations && vessel.content.registrations.length) {
    <div>
      <h2>Registrations</h2>
      <mat-list>
        @for (registration of vessel.content.registrations; track registration.code) {
          <mat-list-item>
            <mat-icon matListItemIcon>app_registration</mat-icon>
            <span matListItemTitle>{{ registration.code }}</span>
            @if (registration.year) {
              <span matListItemLine><b>Registered in:</b> {{ registration.year }}</span>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  }

  @if (vessel.content.harbours && vessel.content.harbours.length) {
    <div>
      <h2>Harbours</h2>
      <mat-list>
        @for (harbour of vessel.content.harbours; track harbour.place) {
          <mat-list-item>
            <mat-icon matListItemIcon>anchor</mat-icon>
            <span matListItemTitle>{{ harbour.place }}</span>
            @if (harbour.country) {
              <span matListItemLine>{{ harbour.country }}</span>
            }
          </mat-list-item>
        }
      </mat-list>
    </div>
  }

  @if (vessel.content.links && vessel.content.links.length) {
    <div>
      <h2>Links</h2>
      <mat-list>
        @for (link of vessel.content.links; track link.href) {
          <mat-list-item>
            <mat-icon matListItemIcon>link</mat-icon>
            <span matListItemTitle>
              <a href="{{ link.href }}" target="_blank">
                {{ link.title || link.href }}
              </a>
            </span>
          </mat-list-item>
        }
      </mat-list>
    </div>
  }
}
